// Chakra imports
import {
  Flex,
  Grid,
  Text,
  useColorModeValue,
  Badge,
  Select,
  Button,
  Input,
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  Checkbox,
  CheckboxGroup,
  Stack,
  Box,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { FaTimes, FaTimesCircle } from "react-icons/fa";
// Custom components
import React, { useEffect, useState } from "react";
import { forEach, get, property, set, upperFirst, filter } from "lodash";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import {
  fetchListingDetails,
  formatAddressFromParts,
} from "../../../../common/listing-converter";
import {
  useHistory,
  NavLink,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import DynamicForm from "../../../../components/DynamicForm";
import FormData from "./FormData";
import { v4 as uuidv4 } from "uuid";
import { LockIcon, UnlockIcon } from "@chakra-ui/icons";

const CreateDeal = ({ onComplete, deal, form, fixWidth, generate, auth }) => {
  console.log({ deal });
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const [visible, setVisible] = useState(true);
  const BLACK = "#000000";
  const GRAY = useColorModeValue("gray.300", "white");
  const { id } = useParams();
  const [mlsData, setMlsData] = useState(null);
  const [MLS, setMLS] = useState(deal?.MLS || "");
  const [step, setStep] = useState(deal ? "2" : "1");
  const [error, setError] = useState(false);
  const [editing, setEditing] = useState(false);
  const [propInfo, setPropInfo] = useState({});
  const [dealInfo, setDealInfo] = useState(
    deal || { deal_type: "Sale", address: "", MLS: "" }
  );
  const [changeAddress, setChangeAddress] = useState(!deal?.MLS);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [uploading, setUploading] = useState(0);
  const [saving, setSaving] = useState(false);
  const history = useHistory();
  const title = "Create New Deal";

  useEffect(() => {
    if (formSubmitted) {
      if (!saving && uploading <= 0) {
        onComplete();
        setFormSubmitted(false);
      }
    }
  }, [saving, uploading, formSubmitted]);

  useEffect(() => {
    if (deal) {
      console.log("go to step 2");
      setMLS(deal.MLS || "");
      setDealInfo(deal);
      setStep("2");
      setChangeAddress(!deal.MLS);
    }
  }, [deal]);

  async function getMLSListingDetails(mlsNum) {
    if (!mlsNum) return null;
    const toSend = await fetchListingDetails(mlsNum);
    if (!toSend) {
      console.log("WRONG MLS");
    }
    console.log("debug", { toSend });

    if (toSend) {
      setMlsData(toSend);
    }
    return toSend;
  }

  const handleProceedWithoutMLS = () => {
    setMlsData(null);
    setPropInfo({});
    setDealInfo((prev) => ({
      ...prev,
      MLS: MLS ? MLS.trim() : "",
      address: prev.address || "",
      deal_type: prev.deal_type || "Sale",
    }));
    setChangeAddress(true);
    setError(false);
    setEditing(false);
    setStep("2");
  };

  async function handleMLSSubmit() {
    if (!MLS || !MLS.trim()) {
      handleProceedWithoutMLS();
      return;
    }
    let resp = await getMLSListingDetails(MLS.trim());
    if (!resp) {
      setError(true);
    } else {
      if (resp.board_2) {
        resp = resp.board_2;
        console.log(resp);
      } else if (resp.board_16) {
        resp = resp.board_16;
      } else if (resp.board_17) {
        resp = resp.board_17;
      }
      const addr = resp.address || {};
      const unitNumber = addr.unitNumber;
      const streetNumber = addr.streetNumber;
      const streetName = addr.streetName || "";
      const streetSuffix = addr.streetSuffix;
      const city = addr.city || "";
      const state = addr.state || "";
      const zip = addr.zip || "";

      const formattedAddress = [
        [unitNumber, streetNumber, streetName, streetSuffix]
          .filter(Boolean)
          .join(" "),
        city,
        state,
        zip,
      ]
        .filter(Boolean)
        .join(", ");

      setPropInfo(resp);
      setDealInfo((prev) => ({
        ...prev,
        MLS: resp._id || MLS.trim(),
        deal_type: resp.type || prev.deal_type || "Sale",
        address: formattedAddress,
      }));
      setChangeAddress(false);
      setError(false);
      setEditing(false);
      setStep("2");
    }
  }

  async function handleFormSubmit(formState, auth, type) {
    const fields = form ? form : FormData.form;
    let toSubmit = {};
    let toUpload = {};

    forEach(fields, (field) => {
      if (formState[field.name] !== undefined) {
        if (field.type === "upload") {
          toUpload[field.name] = filter(formState[field.name], (file) => {
            return file.file && file.size;
          });
        } else {
          toSubmit[field.name] = formState[field.name];
        }
      }
    });

    const mergedPayload = {
      ...dealInfo,
      ...formState,
      address: dealInfo.address || formState.address || "",
      MLS: dealInfo.MLS || formState.MLS || "",
      deal_type: dealInfo.deal_type || formState.deal_type || "Sale",
    };

    const fetchURL = deal ? `/api/deals/${deal._id}` : `/api/deals`;
    console.log("debug", { toSubmit, toUpload, mergedPayload });

    if (deal && Object.keys(toUpload).length > 0) {
      for (let key in toUpload) {
        setUploading((prev) => prev + toUpload[key].length);
        for (let i = 0; i < toUpload[key].length; i++) {
          const uploads = {
            [key]: [
              {
                ...toUpload[key][i],
                id: uuidv4(),
                size: toUpload[key][i].file.size,
              },
            ],
          };
          console.log({
            fetchURL,
            body: {
              uploads,
            },
          });
          try {
            await fetch(fetchURL, {
              method: "PUT",
              body: JSON.stringify({
                uploads,
              }),
              headers: {
                dwelly_token: auth.token,
                "Content-Type": "application/json",
              },
            });
            setUploading((prev) => Math.max(0, prev - 1));
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
    if (Object.keys(toSubmit).length > 0 || !deal) {
      setSaving(true);

      fetch(fetchURL, {
        method: deal ? "PUT" : "POST",
        body: JSON.stringify(mergedPayload),
        headers: {
          dwelly_token: auth.token,
          "Content-Type": "application/json",
        },
      })
        .then(() => {
          setSaving(false);
        })
        .catch((e) => {
          console.log(e);
          setSaving(false);
        });
    }

    setFormSubmitted(true);
  }

  return (
    <Card p={form ? "" : "16px"} style={{ zIndex: 1 }}>
      {visible && (
        <CardBody px="5px">
          <Grid gap={form ? "0" : "24px"}>
            <Flex align="left" mb="18px" direction="column">
              {step !== "2" && (
                <>
                  <FormControl isInvalid={error}>
                    <Text fontWeight="bold" fontSize="md" mb="1">
                      Please Enter The MLS Number of the Associated Property (Optional)
                    </Text>
                    <Text fontSize="sm" color="gray.500" mb="3">
                      Enter an MLS number to automatically populate property details, or proceed without an MLS number to enter details manually.
                    </Text>
                    <Input
                      fontSize="md"
                      color={textColor}
                      placeholder="e.g. C8070466 (Optional)"
                      value={MLS}
                      display={"inline-block"}
                      fontWeight="400"
                      me="10px"
                      onChange={(e) => {
                        setMLS(e.target.value);
                        if (error) setError(false);
                      }}
                    />
                    <br />

                    <Stack direction={{ base: "column", sm: "row" }} mt="4" spacing="3">
                      <Button
                        onClick={handleMLSSubmit}
                        colorScheme="red"
                        size="md"
                      >
                        Continue with MLS
                      </Button>
                      <Button
                        onClick={handleProceedWithoutMLS}
                        variant="outline"
                        colorScheme="gray"
                        size="md"
                      >
                        Proceed Without MLS (Manual Entry)
                      </Button>
                    </Stack>
                    <Alert status="warning" borderRadius="md" mt="4">
                      <AlertIcon />
                      <Box>
                        <AlertTitle fontSize="sm" fontWeight="bold">
                          Notice on Deals Without MLS
                        </AlertTitle>
                        <AlertDescription fontSize="xs">
                          Proceeding without an MLS number means property details won't be auto-filled, and automatic PDF document generation (Trade Sheets, Commission Statements, etc.) will fail for this deal.
                        </AlertDescription>
                      </Box>
                    </Alert>
                    {error && (
                      <Box mt="3">
                        <FormErrorMessage display="block" mb="1">
                          Invalid MLS number or listing could not be found.
                        </FormErrorMessage>
                        <Button
                          size="sm"
                          variant="link"
                          colorScheme="red"
                          onClick={handleProceedWithoutMLS}
                        >
                          Proceed without MLS and enter address manually &rarr;
                        </Button>
                      </Box>
                    )}
                  </FormControl>
                </>
              )}

              {step === "2" && (
                <>
                  {!dealInfo.MLS && (
                    <Alert status="warning" borderRadius="md" mb="4">
                      <AlertIcon />
                      <Box>
                        <AlertTitle fontSize="sm" fontWeight="bold">
                          Warning: No MLS Number Associated
                        </AlertTitle>
                        <AlertDescription fontSize="xs">
                          This deal has no MLS number. Auto-filled property details and automatic PDF document generation (Trade Sheets, Commission Statements, etc.) will fail for this deal unless a valid MLS number is added.
                        </AlertDescription>
                      </Box>
                    </Alert>
                  )}
                  <FormControl isInvalid={error} mb="4">
                    {!editing && !form ? (
                      <>
                        <FormLabel fontWeight="bold">MLS Number</FormLabel>
                        <Stack direction={"row"}>
                          <Input
                            variant="filled"
                            type="text"
                            placeholder="No MLS Number (Manual Entry)"
                            value={dealInfo.MLS || ""}
                            isReadOnly
                          />
                          <Button
                            onClick={() => {
                              setEditing(true);
                              setMLS(dealInfo.MLS || "");
                            }}
                            colorScheme="red"
                            size="md"
                          >
                            {dealInfo.MLS ? "Edit" : "Add MLS"}
                          </Button>
                        </Stack>
                      </>
                    ) : null}

                    {editing && (
                      <>
                        <FormLabel fontWeight="bold">MLS Number (Optional)</FormLabel>
                        <Stack m="0" p="0" direction={{ base: "column", sm: "row" }} spacing="2">
                          <Input
                            type="text"
                            placeholder="e.g. C8070466 (or leave empty)"
                            onChange={(e) => {
                              setMLS(e.target.value);
                              if (error) setError(false);
                            }}
                            value={MLS}
                          />
                          <Button
                            onClick={handleMLSSubmit}
                            colorScheme="red"
                            size="md"
                          >
                            Fetch MLS
                          </Button>
                          <Button
                            onClick={() => {
                              setDealInfo((prev) => ({
                                ...prev,
                                MLS: MLS ? MLS.trim() : "",
                              }));
                              setEditing(false);
                              setError(false);
                            }}
                            variant="outline"
                            size="md"
                          >
                            Keep Manual MLS
                          </Button>
                          <Button
                            onClick={() => {
                              setMLS(dealInfo.MLS || "");
                              setEditing(false);
                              setError(false);
                            }}
                            variant="ghost"
                            size="md"
                          >
                            Cancel
                          </Button>
                        </Stack>
                        {error && (
                          <FormErrorMessage mt="2" mb="2">
                            Invalid MLS or property listing not found.
                          </FormErrorMessage>
                        )}
                      </>
                    )}
                  </FormControl>

                  {!form && (
                    <FormControl mb="4">
                      <FormLabel fontWeight="bold">Deal Type</FormLabel>
                      <Select
                        value={dealInfo.deal_type || "Sale"}
                        onChange={(e) =>
                          setDealInfo((prev) => ({
                            ...prev,
                            deal_type: e.target.value,
                          }))
                        }
                      >
                        <option value="Sale">Sale</option>
                        <option value="Lease">Lease</option>
                      </Select>
                    </FormControl>
                  )}

                  {!form && (
                    <FormControl isRequired mb="4">
                      <FormLabel fontWeight="bold">Property Address</FormLabel>
                      <Stack m="0" p="0" direction={"row"}>
                        <Input
                          variant={changeAddress ? "outline" : "filled"}
                          type="text"
                          placeholder="e.g. 100 Main Street, Suite 400, Toronto, ON M5V 2T6"
                          value={dealInfo.address || ""}
                          isReadOnly={!changeAddress}
                          onChange={(e) =>
                            setDealInfo((prev) => ({
                              ...prev,
                              address: e.target.value,
                            }))
                          }
                        />
                        <Button
                          onClick={() => {
                            setChangeAddress(!changeAddress);
                          }}
                          variant="unstyled"
                          title={
                            changeAddress
                              ? "Lock address field"
                              : "Unlock to edit address"
                          }
                        >
                          {changeAddress ? (
                            <UnlockIcon color={"green.500"} />
                          ) : (
                            <LockIcon color={"red.500"} />
                          )}
                        </Button>
                      </Stack>
                    </FormControl>
                  )}

                  <DynamicForm
                    fixWidth={fixWidth}
                    formData={form ? form : FormData.form}
                    onFormSubmit={handleFormSubmit}
                    inline={true}
                    btnText={"Save"}
                    data={dealInfo}
                    viewOnly={editing ? deal?.locked : false}
                    saving={saving}
                    generate={generate}
                    uploading={uploading}
                    auth={auth}
                  />
                </>
              )}
            </Flex>
          </Grid>
        </CardBody>
      )}
    </Card>
  );
};

export default CreateDeal;
